import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getTimeStamp = (dateObj: Date): string => {
  const date = new Date(dateObj)
  const now = new Date()
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000)

  const intervals: { [key: string]: number } = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1,
  }

  for (const interval in intervals) {
    const value = Math.floor(seconds / intervals[interval])
    if (value >= 1) {
      return `${value} ${interval}${value > 1 ? 's' : ''} ago`
    }
  }

  return 'just now'
}

export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const bytesToSize = (bytes: number) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`
}

/**
 * Replaces placeholders in a template string with values from a data object.
 * Placeholders are expected in the format {{key}}.
 *
 * @param template The template string containing placeholders.
 * @param placeholders An object where keys match the placeholder names.
 * @returns The string with all placeholders replaced.
 */
export function replaceTemplatePlaceholders<T extends Record<string, string>>(
  template: string,
  placeholders: T
): string {
  let result = template
  for (const key in placeholders) {
    if (Object.prototype.hasOwnProperty.call(placeholders, key)) {
      const placeholderRegex = new RegExp(`{{${key}}}`, 'g')
      result = result.replace(placeholderRegex, placeholders[key])
    }
  }
  return result
}
